/**
 * @flow
 * @format
 */

export const constants = {
  SHOW_MODAL: 'SHOW_MODAL',
  HIDE_MODAL: 'HIDE_MODAL',
  MODAL_SAVE_DESIGN: 'MODAL_SAVE_DESIGN',
  MODAL_OPEN_DESIGN: 'MODAL_OPEN_DESIGN',
  MODAL_FILE_MANAGE: 'MODAL_FILE_MANAGE',
};

export type ModalState = {
  modalProps: {},
  modalType: ?string,
};

export type ModalActions = {
  data?: ModalState,
  type: $Keys<typeof constants>,
};

export const actions = {
  showModal: (data: ModalState): ModalActions => ({
    type: constants.SHOW_MODAL,
    data,
  }),
  hideModal: (data: ModalState): ModalActions => ({
    type: constants.HIDE_MODAL,
    data,
  }),
};

export default { constants, actions };



// WEBPACK FOOTER //
// ./src/actions/modal.js